import { render, staticRenderFns } from "./CompBusinessYearSelect.vue?vue&type=template&id=38b1c1f7&scoped=true"
import script from "./CompBusinessYearSelect.vue?vue&type=script&lang=js"
export * from "./CompBusinessYearSelect.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38b1c1f7",
  null
  
)

export default component.exports